import React, { Fragment, useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Box, Divider } from '@material-ui/core';
import contactIcon from 'assets/svgs/contact.svg';
import { HelpOutline as HelpIcon, Launch as LaunchIcon } from '@material-ui/icons';
import { getBaseUrl } from 'helper/utils';
import HelpModal from './HelpModal.component';
import { FEATURES } from 'helper/basicFeatureFlag';
import { UserPortalContext } from 'context/appcontext';
import { HelpIconButton, HelpMenu, useStyles, HelpMenuItem } from './Help.style';
import { setStartTour as setStartTourAction } from 'components/UserTour/Tour.action';
import {
	HELP,
	TRAINING,
	START_TOUR,
	CONTACT_SALES,
	LUMINATE_CHARTER,
	TRAINING_RESOURCE_URL
} from 'constants/constant';

const Help = ({ cbSetShowPreviewElement }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);
	const [showHelpModal, setShowHelpModal] = useState(false);
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const {
		HELP: {
			SHOW_CONTACT_SALES: showContactSales,
			SHOW_TRAINING: showTraining,
			SHOW_LUMINATE_CHARTER: showLuminateCharter
		}
	} = FEATURES[customerType].PREVIEW_PAGE;
	const open = Boolean(anchorEl);

	const PLANS = `${getBaseUrl()}/plans`;
	const CONTACT_US = `${getBaseUrl()}/contactus`;

	const handleClose = () => setAnchorEl(null);

	const handleClick = (event) => setAnchorEl(event.currentTarget);

	const onStartTourClick = () => {
		cbSetShowPreviewElement();
		handleClose();
		// Trigger FTUX flow from Help -> Start tour
		dispatch(
			setStartTourAction({
				isFirstTimeUser: true,
				isTourFromHelp: true
			})
		);
		// Flag to show tour guides on Preview page
		localStorage.setItem('PreviewElementTourSkip', false);
	};

	const onHelpItemClick = () => {
		handleClose();
		setShowHelpModal((showHelpModal) => !showHelpModal);
	};

	let lastMenuItem = null;
	let lastMenuItemOnClick = null;
	if (showTraining) {
		lastMenuItem = (
			<Box underline="none" className={classes.trainingMenuItem}>
				{TRAINING}
				<IconButton className={classes.launchIcon}>
					<LaunchIcon />
				</IconButton>
			</Box>
		);
		lastMenuItemOnClick = () => window.open(TRAINING_RESOURCE_URL, '_blank', 'noreferrer');
	}
	if (showContactSales) {
		lastMenuItem = (
			<Box underline="none" className={classes.contactSales}>
				<IconButton className={classes.launchIcon}>
					<div style={{ alignSelf: 'center', marginRight: '10px' }}>
						<img src={contactIcon} alt="contact-icon"></img>
					</div>
				</IconButton>
				{CONTACT_SALES}
			</Box>
		);
		lastMenuItemOnClick = () => window.open(CONTACT_US, '_blank', 'noreferrer');
	}

	return (
		<Fragment>
			<Box>
				<HelpIconButton aria-label="Help" onClick={handleClick} id="btn-help">
					<HelpIcon
						style={{
							width: 20,
							height: 20,
							color: 'black'
						}}
					/>
				</HelpIconButton>
				{/* Help Menu */}
				<HelpMenu open={open} anchorEl={anchorEl} onClose={handleClose}>
					<HelpMenuItem id="btn-start-tour" onClick={onStartTourClick}>
						{START_TOUR}
					</HelpMenuItem>
					<Divider />
					<HelpMenuItem onClick={onHelpItemClick}>{HELP}</HelpMenuItem>
					{showLuminateCharter ? (
						<Fragment>
							<HelpMenuItem onClick={() => window.open(PLANS, '_blank', 'noreferrer')}>
								{LUMINATE_CHARTER}
							</HelpMenuItem>
							<Divider />
						</Fragment>
					) : null}
					<HelpMenuItem onClick={lastMenuItemOnClick}>{lastMenuItem}</HelpMenuItem>
				</HelpMenu>
				{showHelpModal ? <HelpModal onClose={() => setShowHelpModal(false)} /> : null}
			</Box>
		</Fragment>
	);
};

export default Help;
